import request from '@/utils/request';
const VUE_APP_GIAM_BASE = process.env.VUE_APP_GIAM_BASE;
// 获取语种列表
export function queryGkLanguage() {
  return request({
    url: '/ads/queryGkLanguage',
    method: 'get',
  });
}

// 获取用户列表
export function userSearch(params) {
  return request({
    baseURL: VUE_APP_GIAM_BASE,
    url: '/sys/user/search',
    method: 'get',
    params: {
      ...params,
    },
  });
}
// 获取产品列表
export function productList(data) {
  return request({
    baseURL: VUE_APP_GIAM_BASE,
    url: '/product/list',
    method: 'post',
    data,
    transformRequest: [
      function (data) {
        return JSON.stringify(data);
      },
    ],
  });
}
